import { Component,  OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule } from '@angular/forms';
import { RouteService } from '../shared/route.service';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { IdTipoVeiculo, Util } from '../shared/Util';
import { OcorrenciaPedagioModel } from '../shared/models/ocorrenciaPedagioModel';
import { NotificationService } from '../shared/notification.service';
import { ObjectParam } from '../shared/interface/generic-interface';
import { ApiConService } from '../shared/api-con.service';



const tipoVeiculos = [
  {codigo: 1 , descricao: 'Auto 2 eixos' },
  {codigo: 2, descricao: 'Auto 3 eixos' },
  {codigo: 3, descricao: 'Auto 4 eixos' },
  {codigo: 4, descricao: 'Caminhão 10 eixos' },
  {codigo: 5, descricao: 'Caminhão 2 eixos'},
  {codigo: 6, descricao: 'Caminhão 3 eixos'},
  {codigo: 7, descricao: 'Caminhão 4 eixos'},
  {codigo: 8, descricao: 'Caminhão 5 eixos'},
  {codigo: 9, descricao: 'Caminhão 6 eixos'},
  {codigo: 10, descricao: 'Caminhão 7 eixos'},
  {codigo: 11, descricao: 'Caminhão 8 eixos'},
  {codigo: 12, descricao: 'Caminhão 9 eixos'},
  {codigo: 13, descricao: 'Motocicleta'},
  {codigo: 14, descricao: 'Ônibus 2 eixos'},
  {codigo: 15, descricao: 'Ônibus 3 eixos'},
  {codigo: 16, descricao: 'Ônibus 4 eixos'},
  {codigo: 17, descricao: 'Cobrança Livre'},
]

@Component({
    selector: 'popup-ocorrencia-pedagio',
    templateUrl: './popup-ocorrencia-pedagio.component.html',
    styleUrls: ['./popup-ocorrencia-pedagio.component.css'],
    standalone: true,
    imports: [FormsModule]
})
export class PopupOcorrenciaPedagioComponent implements OnInit{
  ocorrenciaPedagio: OcorrenciaPedagioModel = new OcorrenciaPedagioModel();
  praca: String = ''
  loading = false;

  constructor(
    private http: HttpClient,
    private util: Util,
    private notificationService: NotificationService,
    private conService: ApiConService
    ) { }

   ngOnInit(): void {  
    this.criarFormulario();
  }


  criarFormulario() {
  
      const idPracaPegadio = window.globalThis['idPracaPedagio']
      const valor = window.globalThis['valor']
      this.praca = window.globalThis['praca']


      this.ocorrenciaPedagio.Empresa = this.util.cnpjEmpresas[0];
      this.ocorrenciaPedagio.IdPracaPedagio = idPracaPegadio;
      this.ocorrenciaPedagio.ValorNovo = this.converteValor(valor)
      this.ocorrenciaPedagio.ValorAntigo =  this.converteValor(valor)
      this.ocorrenciaPedagio.DataOcorrencia = new Date().toLocaleDateString();
      this.ocorrenciaPedagio.IdTipoVeiculo =  IdTipoVeiculo.Pedagio;
      this.ocorrenciaPedagio.Observacoes = 'RADAR MOTORISTA'  

  }

  

  converteValor(valorAntigo: any): number{
    const numberString = valorAntigo?.replaceAll("R$", "").replaceAll(",", ".") ?? '';
    const number = parseFloat(numberString);
    return number
  }

  async onSubmit(){  
    this.loading = true; 
    try {
        const objParam: ObjectParam = {
            pedagioOcorrencia: {
                IdPracaPedagio: this.ocorrenciaPedagio.IdPracaPedagio,
                IdTipoVeiculo: this.ocorrenciaPedagio.IdTipoVeiculo,
                ValorAntigo: this.ocorrenciaPedagio.ValorAntigo,
                ValorNovo: this.ocorrenciaPedagio.ValorNovo,
                Empresa: this.ocorrenciaPedagio.Empresa,
                DataOcorrencia: this.ocorrenciaPedagio.DataOcorrencia,
                Observacoes: this.ocorrenciaPedagio.Observacoes
            }
        };

        const response = await this.conService.post('DCPedagioOcorrencia', objParam);
        document.getElementById('ocorrendiaPedagioModal')?.click();
        this.notificationService.showSucesso("Ocorrência criada com sucesso.");
        
        return response[0];
    } catch (error) {
        console.log(error);
    } finally {
        this.loading = false; 
    }
  }
  showErroOcorrencia(){
    this.notificationService.showErro("Erro ao criar ocorrência.");
  }

  
}
